import IcoMoon, { IconProps } from 'react-icomoon'

import iconSet from './selection.json'

const IcomoonIcon = (props: IconProps) => (
  <IcoMoon iconSet={iconSet} {...props} />
)

export default IcomoonIcon
